<template lang="pug">
div(style="min-width: 75px")
  v-menu(v-model="show" rounded="lg" :attach="attach" allow-overflow :close-on-click="!openAddNewDialog" :close-on-content-click="false" offset-y max-height="345")
    template(#activator="{ on }")
      v-sheet.text-sm.border-menu(:class="[{'clickable': !disabled}]" flat outlined height="36" @click="onClickMenu")
        .d-flex.align-center.fill-height.px-4
          div.flex-grow-1
            .text-sm.text-left.neutral700--text(v-if="value") {{ value.value }} {{ 'day' | pluralize({ count:value.value })  }}
            .text-sm.flex-grow-1.neutral500--text.text-left(v-else) Select payment term
          v-progress-circular.mr-2(v-if="isFetching" :width="2" :size="15" color="primary" indeterminate)
          v-icon.mr-1(v-if="value" size="20" @click.stop="handleDeleteSelection") mdi-close
          v-icon(size="24") $yzi-chevron-down
    .text-xs.white
      .search-input
        v-text-field.mb-2.mx-4.text-sm.round-xl(v-model="itemName" outlined :placeholder="$t('search_or_add_new')" dense hide-details autofocus)
        v-divider
        .text-sm.font-normal.pa-4.hover-bg.clickable.d-flex.align-center(@click="handleAddNew")
          v-icon.mr-2(size="16") mdi-plus
          span Add new
      div.d-flex.justify-center(v-if="isFetching")
        v-progress-linear(:width="3" rounded color="primary" indeterminate)
      .d-flex.align-center.justify-space-between.px-4.py-3.neutral300
        .font-semibold.mr-6 Existing payment terms
        y-pagination(v-model="page" :pageSize="pageSize" :count="count" :loading="isFetching") 
      div(v-for="item in paymentTerms" @click="onSelectItem(item)")
        .d-flex.align-center.px-4.py-3.clickable.hover-bg
          .text-sm.font-normal.flex-grow-1 {{ item.value }} {{ 'day' | pluralize({ count:item.value })  }}
          v-btn(x-small icon color="transparent" @click.stop="handleDeleteItem(item)")
            v-icon(small color="neutral500") mdi-close
        v-divider
      template(v-if="!paymentTerms.length")
        .px-4.py-3 {{ $t('no_result_match') }}
  .dialogs
    add-new-payment-term-dialog(v-if="openAddNewDialog" :open.sync="openAddNewDialog" @closed="openAddNewDialog = false" @updated="fetchPaymentTerm")
</template>
  
<script>
import { debounce } from '@/utils'
import { mapGetters, mapActions } from 'vuex'
import AddNewPaymentTermDialog from '@/components/clinic/dialogs/purchasehub/AddNewPaymentTermDialog.vue'

export default {
  components: {
    AddNewPaymentTermDialog,
  },
  props: {
    value: {
      type: Object,
      default: null
    },
    disabled: {
      type: Boolean,
    },
    attach: {
      type: Boolean,
    },
  },
  data: () => ({
    isFetching: false,
    show: false,
    itemName: '',
    page: 1,
    pageSize: 10,
    count: 0,
    paymentTerms: [],
    initialized: false,
    openAddNewDialog: false,
  }),
  watch: {
    page () {
      this.fetchPaymentTerm()
    },
    itemName () {
      if (this.noSearch) return

      this.searchStart()
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
  },
  methods: {
    ...mapActions(['showMessage']),
    searchStart: debounce(function () {
      this.page = 1
      this.fetchPaymentTerm()
    }, 750),
    onSelectItem (item) {
      this.$emit('input', item)
      this.$emit('change')
      this.show = false
      this.itemName = ''
    },
    handleAddNew () {
      this.openAddNewDialog = true
    },
    async fetchPaymentTerm() {
      if (this.disabled) return

      if (this.show && !this.initialized) {
        this.show = false
      }

      try {
        this.isFetching = true
        let params = { 
          enabled: true,
          page: this.page,
          page_size: this.pageSize,
          company: this.company.id,
          field: 'purchase.payment_term',
          search: this.itemName || null
        }
        const { data } = await this.$axios.get('/options', { params })
        this.paymentTerms = data.results
        this.count = data.count
      } catch (error) {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      } finally {
        this.isFetching = false
        this.show = true
        this.initialized = true
        this.noSearch = false
      }
    },
    onClickMenu () {
      if (this.itemName.length > 0) {
        this.itemName = ''
        this.noSearch = true
      }
      this.fetchPaymentTerm()
    },
    handleDeleteItem (item) {
      this.isFetching = true
      this.$axios.delete(`/options/${item.id}/`)
        .then(() => {
          this.paymentTerms = this.paymentTerms.filter(paymentTerm => paymentTerm.id !== item.id)
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isFetching = false
        })
    },
    handleDeleteSelection () {
      this.$emit('input', null)
      this.$emit('change')
    },
  }
}
</script>
  
  <style scoped>
  .border-menu {
    border: 1px solid var(--yz-neutral-400);
    border-radius: 10px;
    box-shadow: none;
  }
  .error-border-menu {
    border: 1px solid var(--yz-danger);
    border-radius: 10px;
    box-shadow: none;
  }
  .search-input {
    position: sticky;
    top: 0px;
    background-color: #FFFFFF !important;
    border-color: #FFFFFF !important;
    z-index: 4;
    padding-top: 8px;
  }
  .disabled-item {
    background-color: var(--v-neutral300);
    color: var(--v-neutral500);
  }
  </style>